import React, { useState, useEffect, useContext, } from "react";

import { Modal, Col, Row, Button, NavItem, NavLink, Dropdown, DropdownMenu, DropdownItem, DropdownToggle, ButtonDropdown, Container, Card, CardBody, CardTitle, } from "reactstrap";
import { MoondanceContext } from '../../App';

import MoondanceLayout from '../lib/layout.js';
import { useNavigate } from 'react-router-dom';

import AccountWidget from "../pages/account_widget.js";
export default function SelectAccount(props) {

    return (

        <React.Fragment>
            <div className={'page-content'} >
                <Container fluid={true} >
                    <Row >
                        <Col lg={6} style={{ zIndex: '1000',minHeight:'30em',}}>
                            
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Select Account</h4>
                            </div>

                    <AccountWidget  expanded={true}  compress={false}/>
                        </Col> 
                        </Row>
                </Container>
            </div>

        </React.Fragment >)
}



